//env npm i react-spring @mui/material @mui/styled-engine @emotion/react @emotion/styled
import React, { useState,useEffect }  from 'react'
import { BiPlay,BiStop } from 'react-icons/bi'
import { HiChevronDown } from 'react-icons/hi'
import _ from 'lodash';
let data_horizontal_bar = {  
  "x-label": ["a","b","c","d","e","f"],
  "item":[
      {"id":1,"y-label":"JP","x":"w-[230px]"},
      {"id":2,"y-label":"DE","x":"w-[70px]"
      },
      {"id":3,"y-label":"UK","x":"w-[20px]"},
      {"id":4,"y-label":"US","x":"w-[190px]"},
      {"id":5,"y-label":"CH","x":"w-[90px]"}
  ]
}
let data_vertical_bar = {  
  "y-label": ["a","b","c","d","e","f"],
  "item":[
      {"id":1,"x-label":"JP","y":"h-[70px]"},
      {"id":2,"x-label":"DE","y":"h-[210px]"},
      {"id":3,"x-label":"UK","y":"h-[140px]"},
      {"id":4,"x-label":"US","y":"h-[20px]"},
      {"id":5,"x-label":"CH","y":"h-[90px]"}
  ]
}
function ABC() {
  const [loadingPlay1,setLoadingPlay1]=useState(false)
  const [loadingPlay2,setLoadingPlay2]=useState(false)
  const [barDefault1,setBarDefault1]=useState('unloaded')
  const [barDefault2,setBarDefault2]=useState('unloaded')
  const onClick2LoadingBarReset1=()=>{
    setLoadingPlay1(false)
    setBarDefault1('w-[0px]')
  }
  function initialLoadingBar1(){
    if(barDefault1=='unloaded'){
      setLoadingPlay1(true)
      setBarDefault1('')
    }
  }
  const onClick2LoadingBar1=()=>{
    setLoadingPlay1(true)
  }
  const onClick2LoadingBarReset2=()=>{
    setLoadingPlay2(false)
    setBarDefault2('h-[0px]')
  }
  function initialLoadingBar2(){
    if(barDefault2=='unloaded'){
      setLoadingPlay2(true)
      setBarDefault2('')
    }
  }
  const onClick2LoadingBar2=()=>{
    setLoadingPlay2(true)
  }
  initialLoadingBar1()
  initialLoadingBar2()
  return (
    <>
    <b className='text-[9px]'>horizontal</b>
    <div className='flex m-auto mb-1'>
    <button className='border border-gray-800 hover:bg-gray-200' onClick={onClick2LoadingBar1}>{loadingPlay1?<BiStop/>:<BiPlay/>}</button>
    <button className='text-[9px] pl-1 pr-1 ml-[2px] border border-gray-800 hover:bg-gray-200' onClick={onClick2LoadingBarReset1}>Reset</button>
    </div>
    <div className='flex'>
    <div className='flex flex-col text-[9px] mr-[2px]'>
    {data_horizontal_bar.item.map((x)=><div>{x['y-label']}</div>)}
    </div>
    <div className='border border-gray-800 w-[232px]'>
    {data_horizontal_bar.item.map((x1)=>
    <div className='relative h-[10px] mt-[2px] mb-[3px]'>
    <div className='absolute block h-[10px] bg-[#f5f5f5] w-[230px]'></div>
    <div className={`${loadingPlay1?`${x1.x}`:`${barDefault1}`} absolute block h-[12px]`}>
    <div className={`bg-[#606277] h-[10px] ${loadingPlay1?'bar-loader-x':''}`}></div>
    </div>
    </div>)}
    </div>
    </div>
    <div className='flex'>
    <div className='w-[15.5px]'></div>
    <div className='w-[232px] text-[9px] flex justify-between'>
    {data_horizontal_bar['x-label'].map(()=><div className='border-l border-gray-800 h-[10px]'></div>)}
    </div>
    </div>
    <div className='flex'>
    <div className='w-[14px]'></div>
    <div className='leading-[1em] w-[236px] text-[9px] flex justify-between'>
    {data_horizontal_bar['x-label'].map((x)=><div>{x}</div>)}
    </div>
    </div>
    <b className='text-[9px]'>vertical</b>
    <div className='flex m-auto mb-1'>
    <button className='border border-gray-800 hover:bg-gray-200' onClick={onClick2LoadingBar2}>{loadingPlay2?<BiStop/>:<BiPlay/>}</button>
    <button className='text-[9px] pl-1 pr-1 ml-[2px] border border-gray-800 hover:bg-gray-200' onClick={onClick2LoadingBarReset2}>Reset</button>
    </div>
    <div className='flex'>
    <div className='h-[242px] text-[9px] flex flex-col justify-between'>
    {data_vertical_bar['y-label'].map((x)=><div className=''>{x}</div>)}
    </div>
    <div className='mt-[6px] h-[232px] text-[9px] flex flex-col justify-between'>
    {data_vertical_bar['y-label'].map(()=> <div className='border-b border-gray-800 w-[10px]'></div>)}
    </div>
    <div className='mt-[6px] flex flex-col'>
    <div className='flex border border-gray-800 w-fit pl-[2px]'>
    {data_vertical_bar.item.map((x1)=><div className='relative h-[230px] w-[10px] mr-[3px]'>
    <div className='absolute block w-[10px] bg-[#f5f5f5] h-[230px]'></div>
    <div className={`${loadingPlay2?`${x1.y}`:`${barDefault2}`} absolute bottom-0 block w-[12px]`}>
    <div className={`relative bg-[#606277] w-[10px] h-full ${loadingPlay2?'bar-loader-y':''}`}></div>
    </div>
    </div>)}
    </div>
    <div className='flex text-[9px]'>{data_vertical_bar.item.map((x1)=><div className='ml-[1.2px]'>{x1['x-label']}</div>)}</div>
    </div> 
    </div>
    </>
  )
}
export default ABC